import { render, staticRenderFns } from "./MedicalModal.vue?vue&type=template&id=2258b7eb&scoped=true&"
import script from "./MedicalModal.vue?vue&type=script&lang=js&"
export * from "./MedicalModal.vue?vue&type=script&lang=js&"
import style0 from "./MedicalModal.vue?vue&type=style&index=0&id=2258b7eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258b7eb",
  null
  
)

export default component.exports